import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './components/styles/Theme';
import About from './components/About/About';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import Navbar from './components/Navbar/Navbar';
import Projects from './components/Projects/Projects';
import GlobalStyles from './components/styles/Global';
import ParallaxComponent from './components/Parallax/Parallax';
import Technologies from './components/Technologies/Technologies';
import Blogs from './components/Blogs/Blogs';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <>
          <GlobalStyles />
          <Navbar />
          <Home />
          <Projects />
          <About />
          <ParallaxComponent />
          <Technologies />
          <Blogs />
          <Footer />
          <Analytics />
        </>
      </ThemeProvider>
    </Router>
  );
}

export default App;
